import {Form, Input} from "antd";
import React from "react";

const SocialProfileView = () => {

    return (
        <section className={'pn__employee-create__form__fixed-width social-profiles'}>
            <Form.Item
                label={"LinkedIn Profile Link"}
                name={['social', 'linkedInProfileLink']}
                className={"pn__employee-create__form-item"}
            >
                <Input placeholder={'Enter LinkedIn link'} maxLength={200}/>
            </Form.Item>

            <Form.Item
                label={"Github Link"}
                name={['social', 'gitHubLink']}
                className={"pn__employee-create__form-item"}
            >
                <Input placeholder={'Enter GitHub link'} maxLength={200}/>
            </Form.Item>

            <Form.Item
                label={"Other links"}
                name={['social', 'others']}
                className={"pn__employee-create__form-item"}
            >
                <Input maxLength={200}/>
            </Form.Item>
        </section>
    )
};

export default SocialProfileView;